import React from 'react';
import { MoreIcon, ChevronDownIcon } from 'components/icons';
import DropModal from 'components/shared/DropModal/DropModal';
import { ChartPreferenceMenu } from '../ChartPreferenceMenu';
import styles from './DeviceChartMenuBar.module.css';

function DeviceChartMenuBar({ name, title, onChange, actions }) {
  return (
    <div className={styles.root}>
      <DropModal
        className={styles.menu}
        name={`${name}.options`}
        data-testid="chart-preference-select"
        title={
          <div className={styles.titleContainer}>
            <span className={styles.titleTextOverflow} data-tip={title}>
              {title}
            </span>
            <ChevronDownIcon size="small" className={styles.titleIcon} data-tip="View chart menu" />
          </div>
        }
      >
        <ChartPreferenceMenu onSelect={onChange} dropModalName={`${name}.options`} />
      </DropModal>
      <div className={styles.actions}>
        <DropModal className={styles.drop} name={`${name}.actions`} title={<MoreIcon size="medium" />}>
          {actions}
        </DropModal>
      </div>
    </div>
  );
}

export default DeviceChartMenuBar;
